import React from 'react'
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom'

import ForgetPassword from '../../Auth/ForgetPassword'
import HomePage from '../../Pages/Homepage/index'
import Myprofile from '../../Pages/Myprofile'
import NewPassword from '../../Auth/newPassword/index'

import Mag from '../../Pages/MagReview'
import LeaveManagement from '../../Pages/LeaveManagement'
import Calendar from '../../Pages/Calendar'
import EmployeeDirectory from '../../Pages/EmployeeDirectory'
import Queries from '../../Pages/Queries/index'
import Training from '../../Pages/Training/training'
import AdminLeaveMangagement from '../../AdminDasboard/admin leavemanagement/index'
import AdminLeaveApproval from '../../AdminDasboard/admin leavemanagement/AdminLeaveApproval/index'
import AdminEmployeeDirectory from '../../AdminDasboard/AdminEmployeeDirectory'
import ViewUsers from '../../AdminDasboard/ViewUsers'
import CreateRoles from '../../AdminDasboard/CreateRoles'
import Payslip from "../../Pages/Myprofile/Payslip/index"
import AdminMag from '../../AdminDasboard/PeopleLeadPerformanceManagement/Index'
import CreateProjects from '../../AdminDasboard/CreateProject/index'
import OrgProjects from '../../AdminDasboard/OrgProjects'
import VieworgProjects from '../../AdminDasboard/ViewOrgProjects'
import CreateUsers from '../../AdminDasboard/CreateUser/index'
import Benefits from '../../Pages/Benefits'
import Projects from '../../Pages/Projects/index'
import ViewProject from '../../Pages/Projects/viewProject'
import TeamMemberGoal from '../../Pages/Projects/teamMemberGoal'
import Carousal from '../../AdminDasboard/AdminCarousal/index'
import GoalCheck from '../../Pages/MagReview/goalCheck'
import OrgGoal from '../../Pages/MagReview/orgGoal'
import HolidayCalendar from '../../Pages/HolidayCalendar'
import ReviewPage from '../../AdminDasboard/PeopleLeadPerformanceManagement/reviewPage'
import CreateUser from '../../AdminDasboard/CreateRoles'
import EmployeeDetails from '../../Pages/Myprofile/Employee Details'
import HrDashboard from '../../AdminDasboard/admin leavemanagement/HRDashboard'
import IndividualEmployee from '../../AdminDasboard/admin leavemanagement/HRDashboard/IndividualEmployee'
import PayModule from '../../AdminDasboard/PayModule'
import EmployeePay from '../../AdminDasboard/PayModule/Employeepay/index'
import PaySlipCom from '../../Components/PayslipComponents'
import AdminFaq from '../../AdminDasboard/AdminFaqs'
import PostFaq from '../../Pages/Queries/PostQueries'
import PostPersonalFaq from '../../Pages/Queries/PostPersonalFaq'
import AdminGeneralReplyFaq from '../../AdminDasboard/AdminFaqs/AdminFaqReply/index'
import UserGeneralQueryResponse from '../../Pages/Queries/GeneralQueryResponse/index'
import AdminPersonalReply from '../../AdminDasboard/AdminFaqs/AdminPersonalQueriesView/index'
import PersonalQueriesView from '../../Pages/Queries/PersonalQueries/index'
import UserPersonalReply from '../../AdminDasboard/AdminFaqs/UserPersonalReply/index'
import LayOutV1 from '../../Layouts/NavbarLayout/index'
import PeopleLead from '../../AdminDasboard/PeopleLead/index'
import EmployeeList from '../../AdminDasboard/PeopleLeadPerformanceManagement/EmployeeHistory/index'
import EmployeeEPto from '../../AdminDasboard/PeopleLeadPerformanceManagement/EmployeeEPTODashboard/index'
import Timesheet from '../../Pages/Timesheet/Timesheet'
import AdminTimeSheet from '../../AdminDasboard/AdminTimeSheet/AdminTimeSheet'
import EmployeeTimeSheetInd from '../../AdminDasboard/AdminTimeSheet/components/EmployeeTimeSheet/EmployeeTImeSheet'
import AdminCompoff from '../../AdminDasboard/AdminCompOff/AdminCompoff'
import Applicants from '../../AdminDasboard/Applicants/Applicants'
import InsytixEmployees from '../../AdminDasboard/InsytixEmployees'
export default function Index() {

  return (
    <Router>
      <Routes>
        <Route path="/forgetPassword" element={<ForgetPassword />} />
        <Route path="/" element={<LayOutV1 />}>
          <Route index element={<HomePage />} />
          <Route path='applicants' element={<Applicants/>}/>
          <Route path="insytix-employees" element={<InsytixEmployees />} />
          <Route path="leavemanagement" element={<LeaveManagement />} />
          <Route path="benefits">
            <Route index element={<Benefits />} />
            <Route path="holidayCalendar" element={<HolidayCalendar />} />
          </Route>
          <Route path="calendar">
            <Route index element={<Calendar />} />
          </Route>

          {/* <Route
            path="compenstation"
            element={
              <Compenstation
                show={false}
                handleClose={function (): void {
                  throw new Error("Function not implemented.");
                }}
              />
            }
          /> */}
          <Route path="myprofile">
            <Route index element={<Myprofile />} />
            <Route path="employeeDetails" element={<EmployeeDetails />} />
            <Route path="payslip" element={<Payslip />} />
          </Route>
          <Route path="createRoles" element={<CreateUser />} />
          <Route path="mag">
            <Route index element={<Mag />} />
            <Route path="goalCheck" element={<GoalCheck />} />
            <Route path="orgGoal" element={<OrgGoal />} />
          </Route>

          <Route path="queries">
            <Route index element={<Queries />} />
            <Route
              path="personal/:personalFaqId"
              element={<PersonalQueriesView />}
            />
            <Route path=":faqId" element={<UserGeneralQueryResponse />} />
            <Route path="electronicQueries" element={<PostFaq />} />
            <Route path="personalQueries" element={<PostPersonalFaq />} />
          </Route>
          <Route path="training" element={<Training />} />
          <Route path="timesheet" element={<Timesheet />} />
          <Route path="createRoles" element={<CreateRoles />} />
          <Route path="projects">
            <Route index element={<Projects />} />
            <Route path=":viewProjectId">
              <Route index element={<ViewProject />} />
              <Route
                path="projectMember/:memberOrgUserID"
                element={<TeamMemberGoal />}
              />
            </Route>
          </Route>
          <Route path="employeedirectory" element={<EmployeeDirectory />} />
          <Route path="adminPerformance">
            <Route index element={<AdminMag />} />
            <Route path="empoyee_list">
              <Route index element={<EmployeeList />} />
              <Route path=":employeeId" element={<EmployeeEPto />} />
            </Route>
            <Route path=":reviewId">
              <Route index element={<ReviewPage />} />
            </Route>
          </Route>
          <Route path="adminleavemngmnt">
            <Route index element={<AdminLeaveMangagement />} />
            <Route path=":employeeUserId" element={<AdminLeaveApproval />} />
            <Route path="employeeDetails">
              <Route index element={<HrDashboard />} />
              <Route path=":employeeId" element={<IndividualEmployee />} />
            </Route>
          </Route>
          <Route path="adminFaqs">
            <Route index element={<AdminFaq />} />
            <Route path=":faqId" element={<AdminGeneralReplyFaq />} />
            <Route path="users/:userId">
              <Route index element={<AdminPersonalReply />} />
              <Route path="reply/:faqId" element={<UserPersonalReply />} />
            </Route>
          </Route>
          <Route path="adminemployeedirectory">
            <Route index element={<AdminEmployeeDirectory />} />
            <Route path=":orgUserId" element={<ViewUsers />} />
            <Route path="peopleLead" element={<PeopleLead />} />

            <Route path="createUser" element={<CreateUsers />} />
          </Route>
          <Route path="orgProjects">
            <Route index element={<OrgProjects />} />
            <Route path=":projectId" element={<VieworgProjects />} />
            <Route path="createProjects" element={<CreateProjects />} />
          </Route>
          <Route path="employeeTimeSheet">
            <Route index element={<AdminTimeSheet />} />
            <Route path=":employeeIdInd" element={<EmployeeTimeSheetInd />} />
          </Route>
          <Route path="pay">
            <Route index element={<PayModule />} />
            <Route path=":employeeId">
              <Route index element={<EmployeePay />} />
              <Route path="paySlip" element={<PaySlipCom />} />
            </Route>
          </Route>

          <Route path='compoff' element={<AdminCompoff/>}/>
        </Route>

        <Route path="/carousal" element={<Carousal />} />
        <Route path="/createNewPassword" element={<NewPassword />} />
      </Routes>
    </Router>
  )
}
